export default "__VITE_ASSET__D80d9cI9__"